import React from 'react'
import {FC} from 'react'
import {Col, Row} from 'antd/lib/grid'
import IDS from '../../../constants/ids'
import LABELS from '../../../constants/labels'
import {STANDARD_ITEM_RULES} from '../../../../../common/constants'
import Input from 'antd/lib/input'
import {COMPONENT_SIZE} from '../../../constants'
import Form from 'antd/lib/form'
import PhoneItem from '../../../../../../common/components/form-items/phone-item'
import Spin from 'antd/lib/spin'
import GlobalOptionsInterface from '../../../types/global-options'
import FormEntityInterface from '../../../../common/models/form-entity-interface'

const {Item} = Form

interface IndividualProps extends FormEntityInterface  {
    isForAgents: boolean
    globalOptions: GlobalOptionsInterface
}

const Individual: FC<IndividualProps> = ({isForAgents, globalOptions, path = []}) => {
    return (
        <>
            <Row gutter={24}>
                <Col xs={24} sm={24} md={12} lg={12}>
                    <Item
                        name={[...path, IDS.CONTACT_NAME]}
                        label={isForAgents ? LABELS.CONTACT_NAME_INSURER : LABELS.CONTACT_NAME}
                        rules={STANDARD_ITEM_RULES}
                        initialValue={globalOptions.userName ? globalOptions.userName : ''}
                        required
                    >
                        <Input size={COMPONENT_SIZE}/>
                    </Item>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col xs={24} sm={24} md={12} lg={12}>
                    {isForAgents ? (
                        <Form.Item
                            name={[...path, IDS.EMAIL]}
                            label={'E-mail'}
                            initialValue={globalOptions.userMail ? globalOptions.userMail : ''}
                            rules={[
                                {
                                    required: true,
                                    whitespace: true,
                                    type: 'email',
                                    message: 'Укажите адрес электронной почты',
                                },
                            ]}
                        >
                            <Input/>
                        </Form.Item>
                    ) : (
                        <Form.Item
                            name={[...path, IDS.EMAIL]}
                            label={'E-mail'}
                            rules={[
                                {
                                    required: true,
                                    whitespace: true,
                                    type: 'email',
                                    message: 'Укажите адрес электронной почты',
                                },
                            ]}
                        >
                            <Input/>
                        </Form.Item>
                    )}
                </Col>
                <Col xs={24} sm={24} md={12} lg={12}>
                    {isForAgents ? (
                        <Item
                            name={[...path, IDS.CONTACT_PHONE]}
                            label={'Телефон'}
                            rules={STANDARD_ITEM_RULES}
                            initialValue={globalOptions.userPhone ? globalOptions.userPhone : ''}
                            required
                        >
                            <Input size={COMPONENT_SIZE}/>
                        </Item>
                    ) : (
                        <PhoneItem name={[...path, IDS.CONTACT_PHONE]}/>
                    )}
                </Col>
            </Row>
            <Row
                justify={'center'}
                gutter={24}
                style={{display: 'none'}}
            >
                <Spin size='large'/>
            </Row>
        </>
    )
}

export default Individual